import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGridsomeComponent } from './simple-icons-gridsome.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGridsomeComponent ],
    exports:      [ SimpleIconsGridsomeComponent ],
    bootstrap:    []
})
export class SimpleIconsGridsomeModule {}
